import { FC, useCallback, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CustomAccordion from "../../../components/CustomAccordion/CustomAccordion";
import {
  T_FaqCategoryItems,
  T_FaqListItemList,
  T_FaqListItems,
} from "../GeneralAppElements_Types";
import {
  defaultEmptyFun,
  FaqApiAbortController,
  getGTAEventScreenType,
} from "../../../utils/helper";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";
import "./FaqItemList.scss";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { triggerCleverTapEvent } from "../../../utils/CleverTap";
import TriggerGTAEvent from "../../../utils/GTA";
import { useLocation } from "react-router-dom";
import useHflFaqApi from "../../../hooks/useHflFaqApi";

interface Props {
  category: T_FaqCategoryItems;
  handleCategory: Function;
  selectedModule: string;
  handleChatOpen: Function;
}

const FaqItemList: FC<Props> = ({
  category,
  handleCategory = defaultEmptyFun,
  selectedModule,
  handleChatOpen,
}) => {
  const [menus, setMenus] = useState<T_FaqListItems[]>([]);
  const [showShimmer, setShowSimmer] = useState<boolean>(false);
  const [selectedFAQ, setSelectedFAQ] = useState<string>("");
  const { callHflFaqCreateCaseApi, callFetchFaqListApi } = useHflFaqApi();

  const handleCleverTapCTAClick = (subcategory: string) => {
    triggerCleverTapEvent("get_help_faq_sub_cat_click", {
      ScreenName: "HelpPopUp",
      isPrevPageNameRequired: true,
      FaqCategory: category.attributes.categoryName,
      FaqSubCategory: subcategory,
    });
  };

  const { pathname } = useLocation();
  useEffect(() => {
    if (category.moduleName) {
      callFetchFaqListApi(
        category.attributes.key,
        category.moduleName,
        setShowSimmer,
      ).then((data) => setMenus(data));
    }
  }, [category]);

  const handleClick = useCallback(() => {
    handleCategory(category, false);
  }, [handleCategory, category]);

  const openChatWithUs = useCallback(() => {
    handleChatOpen();
  }, []);

  // useEffect(() => { //commented for now as there is no usage, if required uncomment accordingly
  //   return () => {
  //     FaqApiAbortController.AbortController?.abort();
  //   };
  // }, []);

  const handleGTAEvents = (sub_cat: string) => {
    TriggerGTAEvent("get_help_faq_sub_cat_click", {
      faq_category: category.attributes.categoryName,
      faq_sub_category: sub_cat,
      screen_type: getGTAEventScreenType(pathname)?.screen_type,
      screen_name: getGTAEventScreenType(pathname)?.screen_name,
    });
  };

  const handleAccordionClick = useCallback(
    (questionData: T_FaqListItemList) => {
      handleCleverTapCTAClick(questionData.question);
      setSelectedFAQ((prevState) => {
        return questionData.question === prevState ? "" : questionData.question;
      });
      if (category?.moduleName === "home-loan") {
        callHflFaqCreateCaseApi(questionData);
      }
      handleGTAEvents(questionData.question);
    },
    [category?.moduleName],
  );

  return (
    <Box className="faq-list-popup-body">
      <Box className="Title">
        <Box className="Titleicon">
          <ChevronLeftIcon className="Titleicon-svg" onClick={handleClick} />
        </Box>

        <Box className="Titlename">
          <Typography variant="h3" className="faq-list-style">
            {category.attributes.categoryName}
          </Typography>
        </Box>
      </Box>
      {showShimmer ? (
        <>
          {[1, 2].map((data) => {
            return (
              <Box
                className="accordian-content"
                sx={{ padding: "1.125rem 1.5rem !important" }}
                key={data}
              >
                <CustomShimmer width="100%" height="1.063rem" />
              </Box>
            );
          })}
        </>
      ) : (
        <>
          {menus.length > 0 ? (
            menus.map((data: T_FaqListItems) => {
              return (
                <Box
                  className="accordian-content"
                  key={data.attributes.question}
                >
                  <CustomAccordion
                    title={data.attributes.question}
                    withCustom={true}
                    expandedIcon={<RemoveIcon />}
                    notExpandedIcon={<AddIcon />}
                    handleAccordionClick={() =>
                      handleAccordionClick(data?.attributes)
                    }
                  >
                    <Typography variant="h6">
                      <div
                        className="answer-content"
                        dangerouslySetInnerHTML={{
                          __html: data.attributes.answer,
                        }}
                      />
                    </Typography>
                  </CustomAccordion>
                </Box>
              );
            })
          ) : (
            <Typography
              sx={{ textAlign: "center", marginTop: ".75rem" }}
              variant="h5"
            >
              No FAQ's found
            </Typography>
          )}
          {/* <Button className="faq-get-in-touch" onClick={openChatWithUs}>
            <Typography variant="h4">
              Didn't find your question? Get in touch
            </Typography>
          </Button> */}
        </>
      )}
    </Box>
  );
};
export default FaqItemList;
